<template>
  <div>
    <a-tabs default-active-key="sharing-policy" @change="handleTabChange">
      <a-tab-pane v-for="item in tabs" :key="item.key" :tab="item.label" />
    </a-tabs>
    <div class="mt-2">
      <keep-alive>
        <component
          :is="currentTab"
          :id="id"
          :resId="resId"
          :data="data"
          :getParams="getParams"
          :accountData="accountData" />
      </keep-alive>
    </div>
  </div>

</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import SharingPolicy from './SharingPolicy'
import SharingRecord from './SharingRecord'

export default {
  name: 'BillSharingForCloudaccountSidepage',
  components: {
    SharingPolicy,
    SharingRecord,
  },
  mixins: [WindowsMixin, ListMixin],
  props: {
    id: String,
    resId: String,
    data: Object,
    getParams: [Function, Object],
    accountData: Object,
  },
  data () {
    return {
      currentTab: 'sharing-policy',
    }
  },
  computed: {
    tabs () {
      const tabs = [
        { key: 'sharing-policy', label: this.$t('bill.sharing_policy') },
        { key: 'sharing-record', label: this.$t('bill.sharing_record') },
      ]
      return tabs
    },
  },
  methods: {
    handleTabChange (tab) {
      this.currentTab = tab
    },
  },
}
</script>
